import {ReactComponent as EditIcon} from './edit.svg'

function Edit() {
  return <EditIcon />
}

export default Edit
